import { Controller } from '@hotwired/stimulus';
import axios from "axios";

export default class extends Controller {
    static values = {
        clubId: Number,
    }
    connect() {
        this.trainersContainer = this.element.querySelector('#trainersContainer');
        this.typeSelector = this.element.querySelector('#typeSelector');
        this.adminAjaxUrl = '/wp-admin/admin-ajax.php';
        this.loader = this.element.querySelector('.loader');
        this.currentTimeout = null;
        //this.displayedPosts = this.element.dataset.displayedPosts;

        this.typeSelector.addEventListener('change', ()=>{
            this.loadPosts(500, this.typeSelector.value, this.clubIdValue);
            console.log(this.typeSelector.value, this.clubIdValue);
        })
    }



    loadPosts(delay, type, club) {
        clearTimeout(this.currentTimeout);
        this.currentTimeout = setTimeout(() => {
            this.trainersContainer.innerHTML = '';
            this.loader.classList.remove('d-none');

            let formData = new FormData;
            formData.append('action', 'trainers_load_posts');
            formData.append('category', type);
            formData.append('club', club);

            axios.post(this.adminAjaxUrl, formData).then((response)=>{
                if (response.data.html) {
                    this.loader.classList.add('d-none');
                    this.trainersContainer.innerHTML += response.data.html;
                }
            });
        }, delay);
    }
}
